import { cn } from "../../utils/useFunctions";

const Container = ({ children, className, classnameInner = `  pt-[56px] h-full ` }) => {
  return (
    <div className={cn(className)}>
      <div className={classnameInner}>{children}</div>
    </div>
  );
};

export default Container;
